module.exports = __webpack_public_path__ + "img/home-3.188036cb.jpg";